import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { INGESTION_DATA_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';
import { getFiBankStore } from 'stores/FiBankStore';
import { DateTimeHelpers } from 'util/dateTime.util';

export function useIngestionData(dispensaryId: string, startDate: string, endDate: string) {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();
  const timezone = getFiBankStore().bank.iana_timezone;

  const formattedStartDate = DateTimeHelpers.formatISOToDateString(startDate, timezone);
  const formattedEndDate = DateTimeHelpers.formatISOToDateString(endDate, timezone);

  const { data: ingestionData, isLoading: isLoadingIngestionData } = useQuery({
    enabled: !!dispensaryId.length && !!userBankId.length && !!startDate.length && !!endDate.length,
    queryKey: [INGESTION_DATA_KEY, userBankId, dispensaryId, formattedStartDate, formattedEndDate],
    queryFn: () =>
      banksApi.getDispensaryIngestionData(userBankId, dispensaryId, formattedStartDate, formattedEndDate)
  });

  return { ingestionData, isLoadingIngestionData };
}
